import {create} from "zustand";

export const useFuncionesCarrito = create((set, get) => {


    const verificarProductoCarrito = (e) => {

        let products = get().productos
        let index = products.findIndex((it) => it.id === e.id)

        if (index >= 0) {
            return products[index].cantidad
        } else {
            return 0
        }


    }

    const quitarProducto = (e) => {

        let products = get().productos
        let index = products.findIndex((it) => it.id === e.id)

        products.splice(index, 1)

        set(() => ({productos: products}))

    }


    const adicionarProducto = (producto) => {

        let productosArr = get().productos
        let index = productosArr.findIndex((it) => it.id === producto.id)

        if (index > -1) {
            let productoActual = productosArr[index]
            productoActual.cantidad = productoActual.cantidad + producto.cantidad
            productosArr[index] = productoActual
        } else {
            productosArr.push(producto)
        }

        set(() => ({productos: productosArr}))
    }


    const adicionarCantidadProducto = ({idProducto, cantidad = 1}) => {

        let productosArr = get().productos
        let index = productosArr.findIndex((it) => it.id === idProducto)

        if (index > -1) {
            let productoActual = productosArr[index]
            productoActual.cantidad = productoActual.cantidad + cantidad
            productosArr[index] = productoActual

            set(() => ({productos: productosArr}))
        }

    }

    const restarCantidadProducto = ({idProducto, cantidad = 1}) => {

        let productosArr = get().productos
        let index = productosArr.findIndex((it) => it.id === idProducto)


        if (index > -1) {
            let productoActual = productosArr[index]
            if (productoActual.cantidad >= 2) {
                productoActual.cantidad = productoActual.cantidad - cantidad
                productosArr[index] = productoActual
                set(() => ({productos: productosArr}))
            } else {

                productosArr.splice(index, 1)
                set(() => ({productos: productosArr}))
            }


        }

    }

    const limpiarCarrito = () => {
        set(() => ({productos: []}))
    }



    return {
        productos: [],
        adicionarProducto,
        verificarProductoCarrito,
        quitarProducto,
        adicionarCantidadProducto,
        restarCantidadProducto,
        limpiarCarrito,

    }
})